import { TObject } from 'utils/types';

import { IMerchantGroup, IMerchantGroupData, IMerchantGroupWithTerminals } from './types';

export const normalizeMerchantGroupWithTerminals = (
  data: TObject,
): IMerchantGroupWithTerminals => {
  return {
    id: (data?.id as number) || 0,
    merchantTerminals: ((data?.merchantTerminals as TObject[]) || []).map((terminal) => ({
      enabled: !!terminal?.enabled,
      id: (terminal?.id as number) || 0,
      name: (terminal?.name as string) || '',
    })),
    name: (data?.name as string) || '',
  };
};

export const normalizeMerchantGroup = (data: IMerchantGroupData): IMerchantGroup => {
  return {
    created: (data?.created as string) || '',
    email: !!data?.email,
    firstName: !!data?.firstName,
    id: (data?.id as number) || 0,
    lastName: !!data?.lastName,
    merchant: {
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    merchantTerminalIds: (data?.merchantTerminalIds as number[]) || [],
    merchantTerminalNames: (data?.merchantTerminalNames as string[]).sort() || [],
    name: (data?.name as string) || '',
    phone: !!data?.phone,
  };
};
